import { doFetchProductDetails, doFetchProductsAttributes, doFetchConfiguredProductDetails, doFetchPartPrice, doPatchOne } from '@/services/product.service';
import { getField, updateField } from 'vuex-map-fields';
import humps from 'lodash-humps';


export const productOne = {
    namespaced: true,
    state: {
        fetchInProgress: true,
        configuredProductProgress: true,
        productDetails: {},
        productMedia: {},
        errorMessage: null,
        productAttributes: {},
        configuredProductDetails: {},
        fetchPriceInProgress: false,
        staticDataOnProduct:null
    },
    getters: {
        getField
    },
    mutations: {
        updateField,
        fetchInProgress(state, yesOrNo) {
            state.fetchInProgress = yesOrNo
        },
        setProductsDetails(state, details) {
            
            state.productDetails =  details;
            // eslint-disable-next-line no-debugger
          //  debugger
        },
        setStaticDataOnProduct(state, details) {
            state.staticDataOnProduct = details
        },
        setProductsAttributes(state, list) {
            state.productAttributes = list
        },
        setErrorMessage(state, err) {
            state.errorMessage = err
        },
        setConfiguredProductDetails(state, details) {
            state.configuredProductDetails = details
        },
        configuredProductProgress(state, yesOrNo) {
            state.configuredProductProgress = yesOrNo
        },
        fetchPriceInProgress(state, yesOrNo) {
            state.fetchPriceInProgress = yesOrNo
        },
    },
    actions: {
        fetchProductDetails: async ({ commit ,dispatch}, {sku,productId}) => {
            try {
                 
                commit('setErrorMessage', null);
                if(productId)
                {
                    
                    let fullCatalog= window.craneCatalog;
                    const product = fullCatalog.products[productId];
                    
                    if(product)
                    {
                        commit('setProductsDetails',
                        {
                            id: product.productId,
                            name: product.n,
                            sku: product.sku,
                            typeId: product.t,
                            description: product.d,
                            mediaGalleryEntries: [{ mediaType: "image", file: product.i }],
                            customAttribute:[],
                        });
                        if(product.t=='configurable')
                        {
                            
                            commit('setConfiguredProductDetails', {'items':[{ mediaGalleryEntries: [{ mediaType: "image", file: product.i }],
                            customAttributes:[] }]});
                        }
                    }

                }
                else
                {
                    commit('setStaticDataOnProduct', null);
                }
                //commit('setProductsDetails', {});
                commit('fetchInProgress', true);
                 const productDetails = await doFetchProductDetails(sku);
                
                if (productDetails) {
                    commit('setProductsDetails', humps(productDetails[0]));
                     let productDetailsNew=humps(productDetails[0]);
                     if(productDetailsNew && productDetailsNew.typeIid=='configurable')
                     {
                        dispatch('fetchConfiguredProductDetails', productDetailsNew.configurableProductLinks[0]);

                     }
                    commit('fetchInProgress', false);
                     return humps(productDetails[0]);
                }
            } catch (err) {
                // state.errorMessage = err.message;
                commit('fetchInProgress', false);
                 commit('setErrorMessage', err.message);
            }
        },
        fetchProductAttribute: async ({ commit }, skuId) => {
            const productAttributes = await doFetchProductsAttributes(skuId);
            if (productAttributes) {
                commit('setProductsAttributes', humps(productAttributes));
                return ({ productAttributes })
            }
        },
        fetchConfiguredProductDetails: async ({ commit }, skuId) => {
            try {
                  
                commit('configuredProductProgress', true);
                const configuredProductDetails = await doFetchConfiguredProductDetails(skuId);
                if (configuredProductDetails) {
                    
                    commit('setConfiguredProductDetails', humps(configuredProductDetails));
                    commit('configuredProductProgress', false);
                }
            } catch (err) {
                commit('configuredProductProgress', false);
                commit('setErrorMessage', err.message);
 
            }
        },
        fetchPartPrice: async ({ commit }, orderObject) => {
            try {
                commit('fetchPriceInProgress', true);
                let price = await doFetchPartPrice({ order: orderObject });
                commit('fetchPriceInProgress', false);
                return price;
            } catch (err) {
                commit('fetchPriceInProgress', false);
                throw err;
            }
        },
        updateCatlog: async () => {
            try {
                await doPatchOne({ "element": "catalog", "requested_at": "" });
            }
            catch (err) {
                throw err;
            }
        },
    },

}